import { CategoryTileProps } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile';
import TagV2, { TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2';
import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import { getLabelByCardType } from '@zola/zola-ui/src/paper/cards/constants/labelByCardType';
import { getCardPlpPath } from '@zola/zola-ui/src/paper/cards/util/getCardUrl';

import { NextCategoryTileImg } from 'components/PreauthV3/NextCategoryTileImage';
import {
  NEW_PAPER_TYPE_NAPKINS,
  NEW_PAPER_TYPE_SIGNAGE,
  NEW_PAPER_TYPE_STICKERS,
} from 'libs/client/utils/experimentFlags';

const DigitalSaveTheDates =
  '/static-preauth/images/PaperLP/v3/ShopByCategory/Digitalsavethedates.jpg';
const EnclosureCards = '/static-preauth/images/PaperLP/v3/ShopByCategory/Enclosurecards.jpg';
const Invitations = '/static-preauth/images/PaperLP/v3/ShopByCategory/Invitations.jpg';
const MatchingSuites = '/static-preauth/images/PaperLP/v3/ShopByCategory/Matchingsuites.jpg';
const Menus = '/static-preauth/images/PaperLP/v3/ShopByCategory/Menus.jpg';
const PlaceCards = '/static-preauth/images/PaperLP/v3/ShopByCategory/Placecards.jpg';
const TableNumbers = '/static-preauth/images/PaperLP/v3/ShopByCategory/Tablenumbers.jpg';
const Programs = '/static-preauth/images/PaperLP/v3/ShopByCategory/Programs.jpg';
const Napkins = '/static-preauth/images/PaperLP/v3/ShopByCategory/Napkins.jpg';
const Signage = '/static-preauth/images/PaperLP/v3/ShopByCategory/Signage.jpg';
const Stickers = '/static-preauth/images/PaperLP/v3/ShopByCategory/Stickers.jpg';
const SaveTheDates = '/static-preauth/images/PaperLP/v3/ShopByCategory/Savethedates.jpg';
const ThankYouCards = '/static-preauth/images/PaperLP/v3/ShopByCategory/Thankyoucards.jpg';
const PaperAddOns = '/static-preauth/images/PaperLP/v3/ShopByCategory/PaperAddOns.jpg';

const NEW_TAG = <TagV2 variant={TagV2Variant.COVE}>New</TagV2>;

type ShopByCategoryTilesAltProps = CategoryTileProps & {
  experimentFlag?: string;
};

const matchingSuitesTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={MatchingSuites} alt="" square />,
  linkText: 'Matching suites',
  href: '/wedding-planning/suites/shop',
};

const saveTheDatesTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={SaveTheDates} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.std),
  href: getCardPlpPath(CARD_TYPE_MAP.std),
};

const digitalSaveTheDatesTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={DigitalSaveTheDates} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.dstd),
  href: getCardPlpPath(CARD_TYPE_MAP.dstd),
};

const invitationsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Invitations} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.invitation),
  href: getCardPlpPath(CARD_TYPE_MAP.invitation),
};
const programsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Programs} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.program),
  href: getCardPlpPath(CARD_TYPE_MAP.program),
};
const napkinsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Napkins} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.napkin),
  href: getCardPlpPath(CARD_TYPE_MAP.napkin),
  experimentFlag: NEW_PAPER_TYPE_NAPKINS,
  tag: NEW_TAG,
};
const signageTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Signage} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.signage),
  href: getCardPlpPath(CARD_TYPE_MAP.signage),
  experimentFlag: NEW_PAPER_TYPE_SIGNAGE,
  tag: NEW_TAG,
};
const stickersTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Stickers} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.sticker),
  href: getCardPlpPath(CARD_TYPE_MAP.sticker),
  experimentFlag: NEW_PAPER_TYPE_STICKERS,
  tag: NEW_TAG,
};
const thankYouCardsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={ThankYouCards} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.thankyou),
  href: getCardPlpPath(CARD_TYPE_MAP.thankyou),
};
const enclosureCardsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={EnclosureCards} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.details),
  href: getCardPlpPath(CARD_TYPE_MAP.details),
};
const menusTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Menus} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.menu),
  href: getCardPlpPath(CARD_TYPE_MAP.menu),
};
const placeCardsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={PlaceCards} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.place),
  href: getCardPlpPath(CARD_TYPE_MAP.place),
};
const tableNumbersTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={TableNumbers} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.tableNumber),
  href: getCardPlpPath(CARD_TYPE_MAP.tableNumber),
};

const paperAddOnsTile: ShopByCategoryTilesAltProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={PaperAddOns} alt="" square />,
  linkText: getLabelByCardType(CARD_TYPE_MAP.paperAddOns),
  href: getCardPlpPath(CARD_TYPE_MAP.paperAddOns),
};

export const shopByCategoryTiles = [
  matchingSuitesTile,
  saveTheDatesTile,
  digitalSaveTheDatesTile,
  invitationsTile,
  programsTile,
  thankYouCardsTile,
  enclosureCardsTile,
  menusTile,
  placeCardsTile,
  tableNumbersTile,
  napkinsTile,
  signageTile,
  stickersTile,
  paperAddOnsTile,
];
